import Nuplay from "../../assets/Nuplay.svg";

export default function MobileMenu() {
  return (
    <div className="mobile-menu-drawer">
      <div className="nurix-container">
        <div className="mobile-menu-drawer-box">
          <div
            id="w-node-_73061154-7480-649b-ba88-5ebeb8004b04-b8004afa"
            className="mobile-menu-link-box"
          >
            <div className="mobile-menu-small-text">About</div>
            <a href="/company" className="mobile-menu-link">
              Company
            </a>
            <a href="/blogs" className="mobile-menu-link">
              Blog
            </a>
            <a href="/career" className="mobile-menu-link">
              Career
            </a>
            <a href="/contact-us" className="mobile-menu-link">
              Contact Us
            </a>
          </div>
          <div
            id="w-node-_42a237c6-64fd-3da7-d42f-8ea90e104819-b8004afa"
            className="mobile-menu-link-box"
          >
            <div className="mobile-menu-small-text">Solutions</div>
            <a href="/agent" className="mobile-menu-link">
              AI Agent
            </a>
            <a href="/agent-assist" className="mobile-menu-link">
              Agent Assist
            </a>
          </div>
          <div
            id="w-node-_0d9e0cd0-14c8-429a-7ddb-fd185673f155-b8004afa"
            className="mobile-menu-link-box"
          >
            <div className="mobile-menu-small-text"></div>
            <a
              href="https://x.com/AI_NURIX"
              target="_blank"
              rel="noreferrer"
              className="footer-text-link"
            ></a>
            <a
              href="https://www.linkedin.com/company/nurixai/"
              target="_blank"
              rel="noreferrer"
              className="footer-text-link"
            ></a>
            <a
              href="https://www.youtube.com/@Nurix-AI"
              target="_blank"
              rel="noreferrer"
              className="footer-text-link"
            ></a>
          </div>
        </div>
      </div>
      <img
        src={Nuplay}
        loading="lazy"
        alt=""
        className="mobile-menu-x-logo"
      />
    </div>
  );
}
